/* BD HERBS — free-delivery bar.
   Dawn replaces the drawer/cart HTML after every quantity change, so the new bar starts from the
   previous fill level and transitions to the new one (smooth grow / shrink instead of a jump). */
if (!customElements.get('bd-free-ship')) {
  customElements.define(
    'bd-free-ship',
    class BdFreeShip extends HTMLElement {
      connectedCallback() {
        const fill = this.querySelector('.bd-ship__fill');
        if (!fill) return;
        const target = Math.min(100, Math.max(0, Number(this.dataset.progress) || 0)) / 100;
        const previous = window.bdShipProgress;
        window.bdShipProgress = target;

        if (previous === undefined || previous === target) return;

        // Commit the old level without a transition (forced style flush), then set the new level:
        // the browser animates between the two committed values. No rAF, so it can't lag behind.
        fill.style.transition = 'none';
        fill.style.setProperty('--bd-ship', previous);
        void getComputedStyle(fill).transform;
        fill.style.transition = '';
        void getComputedStyle(fill).transition;
        fill.style.setProperty('--bd-ship', target);
      }
    }
  );
}
